import Button from '@/shared/Buttons/Button'
import DeleteIcon from '@/assets/icons/trash.svg?react'

interface IProps {
  onClick: () => void
}

const FormDeleteButton = (props: IProps) => {
  return (
    <Button
      size="default"
      type="default"
      icon={<DeleteIcon />}
      text="Удалить"
      onClick={props.onClick}
      buttonType="button"
    />
  )
}

export default FormDeleteButton
